<template>
    <div class="empty-state">
        <EmptyState :title="$t('title')" :description="$t('description')" image="contacts">
            <DsStack align-x="center">
                <DsFilledButton data-qa="connect-button">
                    {{ $t('Add team') }}
                </DsFilledButton>
            </DsStack>
        </EmptyState>
    </div>
</template>

<script>
import { EmptyState } from '@keap-web/shared-ui';

export default {
    components: {
        EmptyState,
    },
};
</script>

<style lang="scss" scoped>
@import "../styles/main.scss";

.empty-state {
    padding-top: $spacing-200;
}
</style>

<i18n>
{
    "en-us": {
        "title": "You don’t have any teams",
        "description": "Get started setting up teams to manage access to all of your client applications.",
        "Add team": "Add team"
    }
}
</i18n>
